/**
 * 车辆评估申请信息详细
 */

import React, { Component } from 'react';
import { Modal, Button, Descriptions, Row, Col } from 'antd';

import ImageView from '../../ui/ImageView';
import Image from '../../ui/Image';

const fields = [{
    "text": "报告编号",
    "field": "valuationNo",
}, {
    "text": "评估日期",
    "field": "valuationDate",
}, {
    "text": "委托方名称",
    "field": "client",
}, {
    "text": "委托方电话",
    "field": "clientTel",
}, {
    "text": "车主名称",
    "field": "owner",
}, {
    "text": "登级证书编号",
    "field": "registerNo",
}, {
    "text": "车架号",
    "field": "vin",
}, {
    "text": "车牌号码",
    "field": "plateNo",
}, {
    "text": "品牌型号",
    "field": "brandModel",
}, {
    "text": "发动机号",
    "field": "engineNo",
}, {
    "text": "车身颜色",
    "field": "colorStr",
}, {
    "text": "表里程数/万公里",
    "field": "mileage",
}, {
    "text": "注册日期",
    "field": "registerDate",
}, {
    "text": "车船使用税截至日期",
    "field": "vehicleTaxProbationEndDate",
}, {
    "text": "交强险截至日期",
    "field": "mandatoryInsuranceDate",
}, {
    "text": "商业险截至日期",
    "field": "commerciaInsuranceDate",
}, {
    "text": "鉴定等级",
    "field": "resultGradeStr",
}, {
    "text": "估值/元",
    "field": "valuationResult",
}, {
    "text": "技术状况",
    "field": "technicalCondition",
    "span": 2
}, {
    "text": "重要配置及参数",
    "field": "importantConfig",
    "span": 2
}, {
    "text": "特别事项说明",
    "field": "specialNotes",
    "span": 2
}];


const image = [{
    text: '证件照正面',
    field: 'identityFrontImg'
}, {
    text: '证件照反面',
    field: 'identityBackImg'
}, {
    text: '机动车登记证首页',
    field: 'registration12Img'
}, {
    text: '机动车登记证尾页',
    field: 'registration34Img'
}, {
    text: '行驶证主页',
    field: 'licenseMainImg'
}, {
    text: '行驶证副页',
    field: 'licenseSubImg'
}, {
    text: '商业险保单图片',
    field: 'commerciaInsuranceImg'
}, {
    text: '交强险保单图片',
    field: 'mandatoryInsuranceImg'
}, {
    text: '公司营业执照或法人证书',
    field: 'corporationCertImg'
}, {
    text: '固定资产车辆清查明细',
    field: 'fixedAssetCertImg'
}, {
    text: '增值税专用发票开具明细',
    field: 'vatInvoiceImg'
}]

class MemberValuateDetail extends Component {

    state = {
        image: null,
        previewVisible: false,
        previewImage: null,
    }

    creaateDetail = (data) => {
        const { editData } = this.props;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let text = editData[data[i]["field"]];
            if (data[i]["format"] != null) {
                text = data[i]["format"][text];
            }
            let span = data[i]["span"] == null ? 1 : data[i]["span"];
            dom.push(<Descriptions.Item key={i} label={data[i]["text"]} span={span}>{text}</Descriptions.Item>);
        }
        return dom;
    }

    // 图片列表
    createImageDom = (field) => {
        let dom = [];
        const { editData } = this.props;
        const imgsInfo = editData.image;
        for (let i = 0; i < field.length; i += 1) {
            let path = imgsInfo != null && imgsInfo[field[i]["field"]] ? "data:image/jpeg;base64," + imgsInfo[field[i]["field"]] : "";
            let imgurl = editData[field[i]["field"]] ? editData[field[i]["field"]] : "";
            let img = (
                <Col span={4} key={i} style={{ margin: '5px 0' }}>
                    <Image
                        onlyView={true}
                        file={path}
                        text={field[i].text}
                        url={imgurl}
                    />
                </Col>
            );
            dom.push(img);
        }
        return (<Row>{dom}</Row>);
    }

    // 其他图片
    otherImgList = () => {
        let dom = [];
        const { editData } = this.props;
        let otherImagesUrl = editData["otherImgs"];
        let image = editData["image"];
        if (otherImagesUrl != null && otherImagesUrl.length > 0) {
            let thumbnails = image.otherImages;
            thumbnails.forEach((item, index) => {
                let image = "data:image/jpeg;base64," + item
                let img = (
                    <Col span={4} key={index} style={{ margin: '5px 0' }}>
                        <Image
                            onlyView={true}
                            file={image}
                            url={otherImagesUrl[index]}
                        />
                    </Col>
                );
                dom.push(img);
            })
        }
        return <Row>{dom}</Row>
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={820}
                visible={visible}
                title="车辆评估详情"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.print}
                footer={[
                    <Button key="cancel" type="default" onClick={onCancel}>确定</Button>,
                ]}
            >
                <Descriptions bordered column={2}>
                    {this.creaateDetail(fields)}
                </Descriptions>
                {this.createImageDom(image)}
                {this.otherImgList()}
                <ImageView src={this.state.previewImage} visible={this.state.previewVisible} handleCancel={this.handleCancel} />
            </Modal>
        );
    }
}


export default MemberValuateDetail;